import React, { useEffect, useRef } from 'react'
import './banner-component.scss'
import { useSelector } from 'react-redux'
import { WarningIcon, SuccessIcon, ErrorIcon } from '../Icon'
import { RootState, store } from '../../../store'
import { showBannerTimeout } from '../../../global-state/banner-slice'

const Banner = () => {
  const { show, text, variant, duration } = useSelector((state: RootState) => state.banner)

  const durationRef = useRef(duration)

  useEffect(() => {
    durationRef.current = duration
  }, [duration])

  useEffect(() => {
    if (show) {
      store.dispatch(showBannerTimeout(durationRef.current))
    }
  }, [show])
  return (
    <>
      {show && (
        <div className={`banner-container ${variant}`}>
          {variant === 'warning-banner' && <WarningIcon type={variant} />}
          {variant === 'success-banner' && <SuccessIcon />}
          {variant === 'error-banner' && <ErrorIcon />}
          <span>{text}</span>
        </div>
      )}
    </>
  )
}

export { Banner }
